export default __webpack_public_path__ + "static/media/SandorAlexandra.6d73f771.jpg";